import React, { Component } from "react";

import image1 from "../../../img/home/home4.jpg";
import image2 from "../../../img/szatnia/Rysunek7.jpg";
import image3 from "../../../img/szatnia/Rysunek13.jpg";
import "./Hero.css";

import {
  CarouselProvider,
  Slider,
  Slide,
  Image,
  DotGroup
} from "pure-react-carousel";
import "../../../../node_modules/pure-react-carousel/dist/react-carousel.es.css";

export default class Hero extends Component {
  render() {
    return (
      <div>
        <CarouselProvider
          naturalSlideWidth={20}
          naturalSlideHeight={10}
          className="carousel"
          totalSlides={3}
          interval={6000}
          isPlaying={true}
        >
          <Slider>
            <Slide index={0} tag="div">
              <Image src={image1} hasMasterSpinner={true} />
            </Slide>
            <Slide index={1}>
              <Image src={image2} hasMasterSpinner={true} />
            </Slide>
            <Slide index={2}>
              <Image src={image3} hasMasterSpinner={true} />
            </Slide>
          </Slider>
          <DotGroup className="px-2 dots d-flex justify-content-center" />
        </CarouselProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Cloackroom/Hero/Hero.js